import { BotSequenceLegacyEnabledLocation } from "@swivl-mono/types";

const MAX_NAMED_LOCATIONS = 5;

/**
 * ENG-3512 (legacy-send-cutover.md §6): the hover hint on the disabled "On" mode option while the
 * legacy engine is still enabled somewhere under this scope. Empty string when nothing blocks it.
 */
export function describeLegacyEnabledHint(locations: BotSequenceLegacyEnabledLocation[]): string {
  if (locations.length === 0) return "";
  const named = locations.slice(0, MAX_NAMED_LOCATIONS).map((location) => location.locationName);
  const hidden = locations.length - named.length;
  const list = hidden > 0 ? `${named.join(", ")} and ${hidden} more` : named.join(", ");
  return `Legacy sequences are still enabled at ${list}. Turn them off in Settings › Sequences before enabling the new engine.`;
}
